<template>
  <footer class="footer">
    <div class="container-fluid">

      <ul class="nav">
        <li class="nav-item">
          <a
            href="/disclosure/"
            target="_blank"
            rel="noopener"
            class="nav-link"
          >
            Risk Disclosure
          </a>
        </li>
        <li class="nav-item">
          <a
            href="/terms-of-service/"
            target="_blank"
            rel="noopener"
            class="nav-link"
          >
            Terms of Service
          </a>
        </li>
        <li class="nav-item">
          <a
            href="/privacy-policy/"
            target="_blank"
            rel="noopener"
            class="nav-link"
          >
            Privacy Policy
          </a>
        </li>
      </ul>
      <div class="copyright">
        &copy; {{ year }} Copyright XABCDTrading.com / XABCD Trading Corp.

      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
